/**
 * Created by litao on 2018/10/8.
 */
import de from "element-ui/src/locale/lang/de";

export default (http) => {
    return {
        /**
         * 分页查询
         * @param data
         * @return {*}
         */
        queryByPage(data) {
            return http.json({
                url: `/sys/company/query?pageNum=${data.pageNum}&pageSize=${data.pageSize}`,
                data
            })
        },
        getInfo(data) {
            return http.json({
                url: `/sys/company/get?id=${data.id}`,
                data
            })
        },


        queryUserList(data) {
            return http.json({
                url: `/sys/company/queryAll`,
                data
            })
        },
        saveInfo(data) {
            return http.json({
                url: `/sys/company/save`,
                data
            })
        },

        queryAddressPage(data) {
            return http.json({
                url: `/dealer/area/query?pageNum=${data.pageNum}&pageSize=${data.pageSize}`,
                data
            })
        },

        saveDealerAddress(data) {
            return http.json({
                url: `/dealer/area/saveBatch`,
                data
            })
        },
        deleteAddress(data) {
            return http.json({
                url: `/dealer/area/delete`,
                data
            })
        },


    }
}



// WEBPACK FOOTER //
// ./src/configure/http/api/company.js